import axios, { AxiosResponse } from 'axios';
import { getApiEnvByHost, getAirwayUrl } from '@/utils/environment';
import { LinkInfoData, IntentData, PayByLinkResponse } from '@/components/paybylink/types';

export const client = axios.create({
  baseURL: `https://api${getApiEnvByHost()}.airwallex.com/api`,
  headers: { 'content-type': 'application/json' },
});

export const airwayClient = axios.create({
  baseURL: getAirwayUrl(),
});

export const getLinkInfo = (
  region: string,
  code: string
): Promise<AxiosResponse<PayByLinkResponse<LinkInfoData & IntentData>>> =>
  airwayClient.get(`/payment-link${region ? `/${region}` : ''}/shopper/${code}`);
